import { getChoicesByName, findChoiceByName } from '@/plugins/choices'

export default function(name = 'timezone')
{
    if (!Intl) {
        return
    }

    let dateTimeFormat = Intl.DateTimeFormat()

    const timezone = dateTimeFormat.resolvedOptions().timeZone

    let choices = getChoicesByName(name)

    choices.forEach(choice => {
        choice.setValue([timezone]) // pre selects the user's timezone.

        let form = choice.passedElement.element.form

        if (form) {
           form.addEventListener('reset', function() {
               findChoiceByName('timezone', form.id)?.setValue([timezone])
           })
        }
    })
}
